import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { ZoomableImage } from './ZoomableImage';
import { toast } from 'sonner';

const sanitize = (s) => (s || 'foto').replace(/[^\w\u00C0-\u017F-]+/g, '_').replace(/_+/g, '_').replace(/^_|_$/g, '');

export const downloadPhoto = async (src, name) => {
  try {
    const res = await fetch(src);
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${sanitize(name)}.jpg`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
    toast.success('Foto descargada');
  } catch {
    toast.error('No se pudo descargar la foto');
  }
};

// Visor de foto con zoom (hasta 600%, pellizco en móvil) para TMs y capturadores
export const PhotoZoomSheet = ({ open, onOpenChange, src, title }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="z-[1450] max-w-[95vw] sm:max-w-2xl bg-[#f8f6f1] p-3 sm:p-5" overlayClassName="z-[1440]" data-testid="photo-zoom-sheet">
      <DialogHeader>
        <DialogTitle className="text-[14px] font-medium pr-6 truncate">{title || 'Foto'}</DialogTitle>
      </DialogHeader>
      {src && <ZoomableImage src={src} alt={title || 'Foto'} maxH="68vh" testId="mobile-photo-zoom" onDownload={() => downloadPhoto(src, title)}/>}
      <p className="text-[10.5px] text-[#8a8579]">Pellizca o usa los botones para acercar · doble toque = 250%</p>
    </DialogContent>
  </Dialog>
);
